import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Form from '../../../components/form/public/Form';
import usePublicForm from '../../../hooks/api/form/usePublicForm';
import LoadingSpinner from '../../../components/layout/loadingSpinner/LoadingSpinner';
import { getSecuritySection, SecurityModel, SecuritySections } from '../../../models/security/security';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useHistory } from 'react-router';
import { FallbackPage } from '../../../components/layout/navbar/Navbar';
import { RouteType } from '../../../routes/routes';
import GoBackButton from '../../../components/layout/pageTitle/BackButton';

interface Props {
  route: RouteType;
}

const FormPreviewPage: FC<Props> = ({ route }) => {
  const [formSecurity, setFormSecurity] = useState<SecurityModel | null>(null);
  const { formId } = useParams<{ formId?: string | undefined }>();
  const { form, organization, setFormId, isLoading } = usePublicForm();
  const security = useSelector((state: RootState) => state.organization.organization?.security);
  const history = useHistory();

  useEffect(() => {
    if (formId) {
      setFormId(formId);
    }
  }, [formId]);

  useEffect(() => {
    if (security) {
      setFormSecurity(getSecuritySection(security, SecuritySections.FORM));
    }
    if (formSecurity && !formSecurity?.read) {
      history.push(FallbackPage);
    }
  }, [security, formSecurity]);

  return (
    <React.Fragment>
      <div className="d-flex align-items-center">
        <div style={{ maxWidth: '1000px', width: '100%' }} className="mx-auto mt-2">
          <GoBackButton backRoute={route} />
        </div>
      </div>
      {(isLoading || !form || !organization) && <LoadingSpinner />}
      {!isLoading && form && organization && (
        <div className="page-content">
          <Form organization={organization} form={form} showShareModal={true}></Form>
        </div>
      )}
    </React.Fragment>
  );
};

export default FormPreviewPage;
